// extracted by mini-css-extract-plugin
module.exports = {"container":"Category_container__khYFL","wrapper":"Category_wrapper__1wi_1","paginate-wrapper":"Category_paginate-wrapper__pI4Jw"};